<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>库存管理</el-breadcrumb-item>
      <el-breadcrumb-item>内部发放-发放列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-button size="mini" plain @click="showSendOrderDialog"
               v-if="authorities.includes('storage.inpurchase.send.new')">新建发放单</el-button>
    <el-date-picker
      v-model="purchaseRequest.selectDate"
      type="daterange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="yyyy-MM-dd"
      size="mini"
      @change="getSelectDate"
    >
    </el-date-picker>
    <el-input v-model="purchaseRequest.name" placeholder="请输入内容" size="mini" style="width: 200px;"></el-input>
    <el-select size="mini" v-model="purchaseRequest.state" clearable placeholder="请选择状态">
      <el-option v-for="item in stateText"
                 :key="item.state"
                 :label="item.name"
                 :value="item.state"></el-option>
    </el-select>
    <el-select v-model="purchaseRequest.inOrgId" size="mini" style="width: 200px" value clearable filterable
               placeholder="请选择机构" class="select">
      <el-option
        v-for="org in sendShop"
        :key="org.id"
        :label="org.orgName"
        :value="org.id">
      </el-option>
    </el-select>
    <el-button size="mini" @click="loadSend">查询</el-button>
    <el-table height="550px" :data="sendPurchaseList" fit border stripe="stripe" :header-cell-style="{background:'#eff3f8', color:'#333'}"
              :row-style="{height: '0'}"
              :cell-style="orderStateColor">
      <el-table-column
        label="操作"
        align="center"
        width="100">
        <template slot-scope="scope">
          <div style="display: flex;justify-content: space-evenly">
<!--              <el-link icon="iconfont icon-bianji" v-if="authorities.includes('send.modify')" size="mini" type="primary"-->
<!--                       @click="showSendOrderDialog(scope.row,2)"></el-link>-->
            <div v-if="authorities.includes('storage.inpurchase.send.cancel')">
              <el-link type="danger" v-if="scope.row.state === 2" :disabled="true"  icon="iconfont icon-zuofei"></el-link>
              <el-link type="danger" v-if="scope.row.state === 1"  icon="iconfont icon-zuofei" @click="cancelPurchase(scope.row)"></el-link>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="state"
        label="状态"
        align="center"
        :formatter="stateFormatter"
        width="100">
      </el-table-column>
      <el-table-column
        prop="purchaseDate"
        label="发放日期"
        align="center" width="120">
      </el-table-column>
      <el-table-column
        prop="productTypeName"
        label="产品分类"
        align="center" width="150">
      </el-table-column>
      <el-table-column
        prop="productName"
        label="产品名称"
        align="center" width="150">
      </el-table-column>
      <el-table-column
        prop="sendNum"
        label="数量"
        align="center" width="60">
      </el-table-column>
      <el-table-column
        prop="purchaseMoney"
        label="发放产品费用"
        align="center" width="100">
      </el-table-column>
      <el-table-column
        prop="senderName"
        label="发放人"
        align="center" width="100">
      </el-table-column>
      <el-table-column
        prop="inOrgName"
        label="接收机构"
        align="center" width="150">
      </el-table-column>
      <el-table-column
        prop="outOrgName"
        label="发放机构"
        align="center" width="120">
      </el-table-column>
      <el-table-column
        prop="comment"
        label="备注"
        align="center" width="150">
      </el-table-column>
      <el-table-column
        prop="purchaseNo"
        label="发放单号"
        align="center" width="250">
      </el-table-column>
    </el-table>
    <div style="margin-top: 3px;">
      <el-pagination
        @size-change="handleSizeChange1"
        @current-change="handleCurrentChange1"
        :current-page="currentPage1"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize1"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal1">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      currentOrgId:'',
      orgLevel:'',
      authorities:'',
      userId:'',

      shop:[],
      sendShop:[],
      sendPurchaseList:[],
      queryText:'',
      sendDialogVisible:false,
      productDialogVisible:false,


      purchase:{
        id:'',
        purchaseDate:'',
        productNo:'',
        purchaseNo:'',
        purchaseMoney:'',
        sender:'',
        inOrgId:'',
        outOrgId:'',
        orgName:'',
        state:'',
        creator:'',
        senderName:'',
        consumptions:[],
      },
      stateText:[
        {state:1, name:'已发送'},
        {state:2, name:'已作废'}
      ],
      operateType:'',
      currentPage1: 1,
      pageSize1:20,
      pageTotal1:0,
      currentPage2: 1,
      pageSize2:20,
      pageTotal2:0,
      purchaseRequest:{
        selectDate:'',
        orgId:'',
        pageNum:'',
        pageSize:'',
        startDate:'',
        endDate:'',
        name:'',
        state:'',
        outOrgId:'',
        inOrgId:''
      },
      createSendDoubleClick:false,

    }
  },
  methods:{
    //显示发放窗口
    showSendOrderDialog(){
      this.$router.push('new/send/purchase')
      // this.operateType = type;
      // if (type === 1){
      //   this.purchase.productNo = '';
      //   this.purchase.purchaseMoney = '';
      //   this.selectProductList = [];
      //   this.purchase.inOrgId = '';
      // }
      // if (type === 2){
      //   this.inOrgId = data.inOrgId;
      //   const {data:res} = await this.$http.get(`/sendPurchase/id/${data.id}`);
      //   this.purchase = res.data;
      //   this.selectProductList = res.data.outsidePurchaseDetails;
      // }
      // this.sendDialogVisible = true;
    },
    //关闭发放窗口
    closeSendDialog(){
      this.sendDialogVisible = false;
    },
    orderStateColor({row,columnIndex}){
      if (row.state === 1 && columnIndex ===1){
        return 'color:#0CB618';
      } else if (row.state === 2 && columnIndex ===1){
        return 'color:#EA1B28';
      }
    },
    //状态方法
    stateFormatter(row){
      let value = "";
      for (let i = 0; i < this.stateText.length; i++){
        let item = this.stateText[i];
        if (row.state === item.state) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    async cancelPurchase(data){
      const {data:res} = await this.$http.post(`/send/cancel`, data);
      if (res.code === 200){
        this.$message.success("操作成功！");
      }
      await this.loadSendList();
    },

    //加载本级机构的下属机构
    async loadSendShop(){
      this.purchaseRequest.startDate = '';
      this.purchaseRequest.endDate = '';
      if (this.purchaseRequest.selectDate !== null){
        this.purchaseRequest.startDate = this.purchaseRequest.selectDate[0];
        this.purchaseRequest.endDate = this.purchaseRequest.selectDate[1];
      }
      this.purchaseRequest.outOrgId = this.currentOrgId;
      const {data:res} = await this.$http.post(`load/send/orgList/`, this.purchaseRequest);
      this.sendShop = res.data;
    },
    getSelectDate(){
      if (this.purchaseRequest.selectDate !== null){
        this.purchaseRequest.startDate = this.purchaseRequest.selectDate[0];
        this.purchaseRequest.endDate = this.purchaseRequest.selectDate[1];
      } else {
        this.purchaseRequest.startDate = '';
        this.purchaseRequest.endDate = '';
      }
    },
    loadSend(){
      this.loadSendTotal();
      this.loadSendList();
    },
    async loadSendTotal(){
      this.purchaseRequest.outOrgId = this.currentOrgId;
      const {data:res} = await this.$http.post(`/send/query/total`, this.purchaseRequest);
      if (res.code === 200){
        this.pageTotal1 = res.totalPage;
      }
    },
    //加载发送列表
    async loadSendList(){
      this.totalMoney = '';
      this.totalNum = '';
      this.purchaseRequest.pageNum = this.currentPage1;
      this.purchaseRequest.pageSize = this.pageSize1;
      this.purchaseRequest.outOrgId = this.currentOrgId;
      const {data:res} = await this.$http.post(`/send/query/list`, this.purchaseRequest);
      if (res.code === 200){
        this.sendPurchaseList = res.data;
      }
      await this.loadSendShop();
    },

    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.loadSendList();
    },
    handleCurrentChange1(val) {
      this.currentPage1 = val;
      this.loadSendList();
    },
  },

  created() {
    this.currentOrgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.currentOrgPurchaseLevel = window.sessionStorage.getItem("currentOrgPurchaseLevel");
    this.orgLevel = window.sessionStorage.getItem("orgLevel");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.loadSendList();
  }
}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 90vh;
}

.left_con{
  display: flex;
  justify-content: start;
  height: 100%;
  overflow-y: auto;
  //flex: 1;
  width: auto;
  //border: 1px solid;
  margin: 10px 0;
  //width: 100px;
}
.left_inner_con{
  width: 300px;
  height: 90vh;
  overflow-y: auto;
  margin-right: 10px;
  //background-color: #F2F6FC;
}

.box-card{
  margin: 10px 10px 10px 10px;
  height: 86%;
}
.spanLabel{
  color: #848484;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}
.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}
.table_container{
  flex: 1;
  width: 800px;
  height: 100%;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/ .el-dialog__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
/deep/.el-dialog__body{
  padding-top: 10px;
}
.dialog-height{
  height: 600px !important;
}
.dialog-footer{
  display: flex;
  margin: 10px 0;
  justify-content: center;
  width: 100%;
}
/deep/ .el-drawer__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Send.vue